import { ViewModelBase } from "@shoothill/core";
import { action, makeObservable, observable } from "mobx";
import { container } from "tsyringe";
import { RelayCommand } from "Application";
import { AccountStore } from "Stores/Domain";
import { CHANGELOG } from "Application/Data/changelog.data";
import { ChangeLogItem, ChangeLogItemType, ChangeLogVersion } from "Application/Models/ChangeLog";

const STORAGE_KEY = "LSRN_lastSeenBuild";

export class WhatsNewViewModel extends ViewModelBase<any> {
    public isOpen: boolean = false;

    constructor() {
        super({});
        makeObservable(this, {
            isOpen: observable,
            setIsOpen: action,
        });
    }

    public checkAndAutoShow(): void {
        const buildLabel = this.getCurrentBuildLabel();
        const hasChangelogEntry = CHANGELOG.some((c) => c.buildLabel === buildLabel);
        if (buildLabel && hasChangelogEntry && localStorage.getItem(STORAGE_KEY) !== buildLabel) {
            localStorage.setItem(STORAGE_KEY, buildLabel);
            this.setIsOpen(true);
        }
    }

    public setIsOpen(value: boolean): void {
        this.isOpen = value;
    }

    private getCurrentBuildLabel(): string {
        return container.resolve(AccountStore).initViewModel.InitData.appSettings?.buildLabel ?? "";
    }

    public get currentEntry(): ChangeLogVersion | null {
        return CHANGELOG[0] ?? null;
    }

    public get groupedItems(): { label: string; items: ChangeLogItem[] }[] {
        if (!this.currentEntry) return [];
        const order: ChangeLogItemType[] = [ChangeLogItemType.Feature, ChangeLogItemType.Improvement, ChangeLogItemType.Fix];
        const labels: Record<ChangeLogItemType, string> = {
            [ChangeLogItemType.Feature]: "Features",
            [ChangeLogItemType.Improvement]: "Improvements",
            [ChangeLogItemType.Fix]: "Fixes",
        };
        return order.map((type) => ({ label: labels[type], items: this.currentEntry!.items.filter((i) => i.type === type) })).filter((g) => g.items.length > 0);
    }

    public openCommand = new RelayCommand(() => this.setIsOpen(true));
    public closeCommand = new RelayCommand(() => this.setIsOpen(false));
}
